import * as React from "react";
const SvgLockedFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M17 5a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v3H6a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-1zm-2 3V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3z", clipRule: "evenodd" }));
export default SvgLockedFill;
